import { Flex } from '@chakra-ui/react'

export const BasicLayout: React.FunctionComponent<{
    children: React.ReactNode
}> = ({ children }) => {
    return (
        <Flex height="100vh" width="100vw">
            {children}
        </Flex>
    )
}
